import { createSelector } from 'reselect';
import { RootState } from '../../store/store';

const state = (s: RootState) => s.platformCompanies;

const companies = createSelector(state, (s) => s.companies);
const filteredCompanies = createSelector(state, companies, (s, list) => {
    const q = s.gridFilter.trim().toLowerCase();
    if (!q) return list;
    return list.filter(
        (c) =>
            c.name?.toLowerCase().includes(q) ||
            c.subDomain?.toLowerCase().includes(q) ||
            c.type?.toLowerCase().includes(q)
    );
});

export const platformCompaniesSelectors = {
    companies,
    filteredCompanies,
    total: createSelector(state, (s) => s.total),
    gridFilter: createSelector(state, (s) => s.gridFilter),
    lastError: createSelector(state, (s) => s.lastError)
};
